import React from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import '../../assets/css/checklist.css';

function ConfirmationPopup({ show, handleClose, title, body, handleConfirm, message, isLoading = false }) {
  return (
    <Modal show={show} onHide={isLoading ? undefined : handleClose} centered className="task-popup confirmation-popup" backdrop={isLoading ? 'static' : true}>
      <Modal.Header closeButton={!isLoading}>
        <Modal.Title>{title}</Modal.Title>
        {isLoading && (
          <div className="d-flex align-items-center ms-3">
            <Spinner animation="border" size="sm" role="status" variant="dark">
              <span className="visually-hidden">Deleting...</span>
            </Spinner>
            <span className="ms-2" style={{ fontSize: '14px' }}>Deleting...</span>
          </div>
        )}
      </Modal.Header>
      <Modal.Body>
        <div className="confirmation-content">
          <div className="confirmation-icon">
            <i className={isLoading ? "bi bi-hourglass-split" : "bi bi-exclamation-triangle"}></i>
          </div>
          <p className="confirmation-text">{isLoading ? "Please wait while deleting..." : body}</p>
          {message && !isLoading && <p className="confirmation-message">{message}</p>}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button className="btn-popup-cancel" onClick={handleClose} disabled={isLoading}>
          Cancel
        </Button>
        <Button className="btn-popup-delete" onClick={handleConfirm} disabled={isLoading}>
          {isLoading ? (
            <>
              <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />
              Deleting...
            </>
          ) : (
            'Confirm'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ConfirmationPopup;
